/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_No_Audio_PlayingInputs */

const en_read_along_no_audio_playing = /** @type {(inputs: Read_Along_No_Audio_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audio playing`)
};

const es_read_along_no_audio_playing = /** @type {(inputs: Read_Along_No_Audio_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay audio reproduciéndose`)
};

/**
* | output |
* | --- |
* | "No audio playing" |
*
* @param {Read_Along_No_Audio_PlayingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_no_audio_playing = /** @type {((inputs?: Read_Along_No_Audio_PlayingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_No_Audio_PlayingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_no_audio_playing(inputs)
	return en_read_along_no_audio_playing(inputs)
});